/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectPersonDropdown_persons = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly role: {
            readonly name: string | null;
        } | null;
        readonly person: {
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly profilePictureId: string | null;
            readonly role: {
                readonly name: string | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "ProjectPersonDropdown_persons";
}>;
export type ProjectPersonDropdown_persons$data = ProjectPersonDropdown_persons;
export type ProjectPersonDropdown_persons$key = ReadonlyArray<{
    readonly " $data"?: ProjectPersonDropdown_persons$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectPersonDropdown_persons">;
}>;



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProjectPersonDropdown_persons",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPerson",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePictureId",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectPersonTypeEdge"
};
})();
(node as any).hash = 'a644052c736d35161d5d19c5c293fe11';
export default node;
